// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RatingRouteImport } from './routes/rating'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SongsSongIdRouteImport } from './routes/songs_.$songId'
import { Route as ChartsTrendingRouteImport } from './routes/charts/trending'
import { Route as ChartsRecentRouteImport } from './routes/charts/recent'
import { Route as SongIdTypeDifficultyRouteImport } from './routes/$songId/$type/$difficulty'
import { Route as SongsSongIdTypeDifficultyRouteImport } from './routes/songs/$songId/$type/$difficulty'
import { Route as IoImportLxnsOauth_callbackRouteImport } from './routes/io/import/lxns/oauth_callback'

const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const RatingRoute = RatingRouteImport.update({
            id: '/rating',path: '/rating',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SongsSongIdRoute = SongsSongIdRouteImport.update({
            id: '/songs_/$songId',path: '/songs/$songId',getParentRoute: () => rootRouteImport
          })
const ChartsTrendingRoute = ChartsTrendingRouteImport.update({
            id: '/charts/trending',path: '/charts/trending',getParentRoute: () => rootRouteImport
          })
const ChartsRecentRoute = ChartsRecentRouteImport.update({
            id: '/charts/recent',path: '/charts/recent',getParentRoute: () => rootRouteImport
          })
const SongIdTypeDifficultyRoute = SongIdTypeDifficultyRouteImport.update({
            id: '/$songId/$type/$difficulty',path: '/$songId/$type/$difficulty',getParentRoute: () => rootRouteImport
          })
const SongsSongIdTypeDifficultyRoute = SongsSongIdTypeDifficultyRouteImport.update({
            id: '/songs/$songId/$type/$difficulty',path: '/songs/$songId/$type/$difficulty',getParentRoute: () => rootRouteImport
          })
const IoImportLxnsOauth_callbackRoute = IoImportLxnsOauth_callbackRouteImport.update({
            id: '/io/import/lxns/oauth_callback',path: '/io/import/lxns/oauth_callback',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RatingRoute: RatingRoute,SearchRoute: SearchRoute,ChartsRecentRoute: ChartsRecentRoute,ChartsTrendingRoute: ChartsTrendingRoute,SongsSongIdRoute: SongsSongIdRoute,SongIdTypeDifficultyRoute: SongIdTypeDifficultyRoute,IoImportLxnsOauth_callbackRoute: IoImportLxnsOauth_callbackRoute,SongsSongIdTypeDifficultyRoute: SongsSongIdTypeDifficultyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)